import { createElement, forwardRef, useImperativeHandle } from 'react';
import { useFullscreen } from './useFullscreen';
import DataVFullScreenContainer from '../fullScreen-container';
const DataVLayouts = forwardRef((props, ref) => {
    const { topRender, hashUseFixed, contentStyle, children } = props;
    const { ref: fullscreenRef, toggle, fullscreen } = useFullscreen();
    useImperativeHandle(ref, () => {
        return {
            toggle,
            fullscreen,
        };
    });
    const child = hashUseFixed && fullscreen ? (createElement(DataVFullScreenContainer, null, children)) : (children);
    return (createElement(React.Fragment, null,
        topRender || null,
        createElement("div", { style: contentStyle, ref: fullscreenRef }, child)));
});
export default DataVLayouts;
